<template>
  <div>
    <!------------------
            HEADER
    -------------------->
    <div class="bg-white p-3 pl-4 page-header" ref="pageHeader" style="padding-bottom: 0">
      <div class="row d-flex align-items-top" style="max-width: 1000px">
        <div class="col">
          <div>
            <h4>
              <b-icon class="me-2" icon="file-earmark"></b-icon>
              {{ order.Ordinal }} {{ order.DisplayName }}
            </h4>
            <div class="text-uppercase text-secondary"><small>Auftrag verwalten</small></div>
          </div>
        </div>
        <div class="col-auto">
          <div class="form-inline">
            <!---------------------------------
                HEADER ACTION BUTTONS
            ---------------------------------->

            <b-button
              variant="light"
              @click="$router.push({ name: 'Hauptauftrag' })"
              size="sm"
              v-if="!$route.path.includes('/view') && ($root.$user.isPlaner || $root.$user.isAdmin)"
            >
              <b-icon icon="file-earmark" variant="dark" class="mr-1"></b-icon>
              Hauptauftrag
            </b-button>
            <b-button
              variant="light"
              class="ml-2"
              @click="$router.push('addendums')"
              size="sm"
              v-if="!$route.path.includes('/addendums') && ($root.$user.isPlaner || $root.$user.isAdmin)"
            >
              <b-icon icon="card-list" variant="dark" class="mr-1"></b-icon>
              Nachträge
            </b-button>

            <b-button
              variant="light"
              @click="$router.push({ name: 'Nachtrag erfassen' })"
              size="sm"
              v-if="$root.$user.isPlaner || $root.$user.isAdmin"
              class="ml-2"
            >
              <b-icon icon="plus" variant="dark" class="mr-1"></b-icon>
              Nachtrag
            </b-button>
            <!-- HELP ICON  -->
            <b-button size="sm" variant="light" class="ml-2" href="https://www.bauvisor.de/auftraege/" target="_blank">
              <b-icon icon="question-circle" variant="dark"></b-icon>
            </b-button>
            <!-- X ICON -->
            <b-button class="ml-2 py-0" variant="light" @click="$router.go(-1)" size="sm">
              <b-icon icon="x" variant="dark" class="" style="height: 24px; width: 24px"></b-icon>
            </b-button>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-white px-4 mt-0 pt-0" style="border-bottom: 1px solid #dee2e6">
      <!----------------------------------------------------------
            S U M M A R Y   H E A D E R   -   R O W   1   |   Gesamtbudget, Nachtragsrückstellung, Status
      ----------------------------------------------------------->
      <div class="row pt-3 pb-0" style="max-width: 1000px">
        <div class="col col-3">
          <label class="text-muted d-block mb-1"><small>Gesamtbudget</small></label>
          <div class="bg-light p-1">
            {{ $utils.formatCurrency(parseFloat(order.BudgetSaldo), SettingsStore) }}
          </div>
        </div>
        <div class="col col-3">
          <label class="text-muted d-block mb-1"><small>Nachtragsrückstellung</small></label>
          <div class="bg-light p-1">
            {{
              $utils.numberWithMaxFrictions(
                ((parseFloat(order.BudgetSaldo) -
                  (parseFloat(order.Amount) + parseFloat(order.AmountAddendumOrdered))) /
                  parseFloat(order.BudgetSaldo)) *
                  100,
                1
              )
            }}
            %
          </div>
        </div>
        <div class="col col-3">
          <label class="text-muted d-block mb-1"><small>&nbsp;</small></label>
          <div class="bg-light p-1">
            {{
              $utils.numberToCurrency(
                parseFloat(order.BudgetSaldo) - (parseFloat(order.Amount) + parseFloat(order.AmountAddendumOrdered)),
                SettingsStore.settings['Centbetraege']
              )
            }}
          </div>
        </div>
        <div class="col col-3">
          <label class="text-muted d-block mb-1"><small>Status</small></label>
          <div class="bg-light p-1">{{ order.ProcessStatus }}</div>
        </div>
      </div>

      <div class="row mt-0 pb-4" style="max-width: 1000px">
        <div class="col col-3" v-show="SettingsStore.settings['KGR_Selections_Active'] == 'true'">
          <label class="text-muted d-block mb-1"><small>Kostengruppe</small></label>
          <div class="bg-light p-1">
            {{ order.KGR ? (order.KGR == '' ? '(leer)' : order.KGR) : '(leer)' }}
          </div>
        </div>
        <div class="col col-3" v-show="SettingsStore.settings['Responsible_Selections_Active'] == 'true'">
          <label class="text-muted d-block mb-1"><small>Verantwortlich</small></label>
          <div class="bg-light p-1">
            {{ order.Responsible ? (order.Responsible == '' ? '(leer)' : order.Responsible) : '(leer)' }}
          </div>
        </div>
        <div class="col col-3" v-show="SettingsStore.settings['FA1_Active'] == 'true'">
          <label class="text-muted d-block mb-1">
            <small>{{ SettingsStore.settings['FA1'] }}</small>
          </label>
          <div class="bg-light p-1">
            {{ order.FA1 ? (order.FA1 == '' ? '(leer)' : order.FA1) : '(leer)' }}
          </div>
        </div>
        <div class="col col-3" v-show="SettingsStore.settings['FA2_Active'] == 'true'">
          <label class="text-muted d-block mb-1">
            <small>{{ SettingsStore.settings['FA2'] }}</small>
          </label>
          <div class="bg-light p-1">
            {{ order.FA2 ? (order.FA2 == '' ? '(leer)' : order.FA2) : '(leer)' }}
          </div>
        </div>
      </div>
    </div>
    <div class="bg-white px-4 mt-0 pt-0" style="border-bottom: 1px solid #dee2e6">
      <div class="row pt-3 pb-0" style="max-width: 1000px">
        <!----------------------------------------------------------
            S U M M A R Y   H E A D E R   -   R O W   2   |   Gesamtauftrag, Hauptauftrag, 
      ----------------------------------------------------------->
        <div class="col">
          <label class="text-muted d-block mb-1"><small>Gesamtauftrag</small></label>
          <div class="bg-light p-1">
            {{
              $utils.formatCurrency(parseFloat(order.Amount) + parseFloat(order.AmountAddendumOrdered), SettingsStore)
            }}
          </div>
        </div>
        <div class="col">
          <label class="text-muted d-block mb-1"><small>HauptauftragXXXX</small></label>
          <div class="bg-light p-1">
            {{ $utils.formatCurrency(order.Amount, SettingsStore) }}
          </div>
        </div>
        <div class="col">
          <label class="text-muted d-block mb-1"><small>Nachträge</small></label>
          <div class="bg-light p-1">
            {{ $utils.formatCurrency(order.AmountAddendumOrdered, SettingsStore) }}
          </div>
        </div>
        <div class="col">
          <label class="text-muted d-block mb-1"><small>Restbudget für Nachträge</small></label>
          <div class="bg-light p-1">
            {{
              $utils.formatCurrency(
                parseFloat(order.BudgetSaldo) - (parseFloat(order.Amount) + parseFloat(order.AmountAddendumOrdered)),
                SettingsStore
              )
            }}
          </div>
        </div>
      </div>
      <div class="row mt-0 pb-4" style="max-width: 1000px">
        <div class="col-3">
          <label class="text-muted d-block mb-1"><small>Auftragnehmer</small></label>
          <div class="bg-light p-1">
            {{ order.SupplierText }}
          </div>
        </div>
        <div class="col-6">
          <label class="text-muted d-block mb-1"><small>Auftragsstatus / Datum</small></label>
          <div class="bg-light p-1">
            {{ computeOrderStatus(order) }}
          </div>
        </div>
        <div class="col-3">
          <label class="text-muted d-block mb-1"><small>Nachträge in Prüfung</small></label>
          <div class="bg-light p-1">{{ $utils.formatCurrency(order.AmountAddendumChecking, SettingsStore) }}</div>
        </div>
      </div>
    </div>
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
import AppState from '@/store/App.js';
import OrdersService from '@/service/OrdersService';
import SettingsStore from '@/store/Settings';

export default {
  data() {
    return {
      order: {
        Ordinal: '',
        DisplayName: '',
        NTR: ''
      },
      isLoading: true,
      SettingsStore
    };
  },
  async activated() {
    await this.loadOrder();
    this.$eventBus.$on('update:nachtrag', () => this.loadOrder());
  },
  methods: {
    loadOrder() {
      OrdersService.getById(this.$route.params.id)
        .then(order => {
          this.order = order;
          if (!this.order.NTR) {
            this.order.NTR = parseFloat(SettingsStore.settings['Nachtragsprozent']).toFixed(2);
          }
          AppState.isLoading = false;
          this.isLoading = false;
        })
        .catch(err => {
          if (err.response) this.$showError(this, err.response.data.error);
          else this.$showError(this, err.toString());
        });
    },
    computeOrderStatus(item) {
      if (item.veSection && item.veSection == 'A') {
        return (
          (item.VergabeEmpfehlung && item.VergabeEmpfehlung != '' ? item.VergabeEmpfehlung : 'Empfehlung') +
          ' / ' +
          this.$utils.SQLDateToGermanDate(item.VergabeEmpfehlungDatum)
        );
      } else if (item.veSection && item.veSection == 'B') {
        return (
          (item.OrderNumber && item.OrderNumber != '' ? item.OrderNumber : 'Bestellung') +
          ' / ' +
          this.$utils.SQLDateToGermanDate(item.OrderDate)
        );
      } else return '';
    }
  }
};
</script>
